import React from 'react';

function Footer() {
    return (
        <footer class="bg-dark text-center text-lg-start">
        <div class="text-center p-3 text-white  justify-content-center" style={{backgroundColor: 'rgba(0,0,0,0.2'}}>
          <p>Powered by <a class="text-white" href="http://open5e.com">Open5e</a></p>
          <p>
          Content provided under the 
          <a class="text-white" href="https://open5e.com/legal/"> OGL 1.0a</a>
            </p>
        </div>
      </footer>
    );
}

export default Footer;


